/* eslint-disable no-use-before-define */
import React from 'react'
import PropTypes from 'prop-types'
import useOpenIds from './useOpenIds'

export const TreeContext = React.createContext(null)

const Container = ({ parentId }) => {
  const context = React.useContext(TreeContext)
  const nodes = context.folders.filter((f) => f.parent_id === parentId)
  const styles =
    context.containerStyles && parentId ? context.containerStyles : {}
  return (
    <div style={styles}>
      {nodes.map((node) => (
        <Node key={node.id} id={node.id} />
      ))}
    </div>
  )
}

Container.propTypes = {
  parentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
}

const Node = ({ id }) => {
  const { openIds, handleToggle, render, folders } =
    React.useContext(TreeContext)

  const open = openIds.includes(id)

  const hasChild = !!folders.find((node) => node.parent_id === id)
  const item = folders.find((node) => node.id === id)

  const toggle = React.useCallback(() => {
    handleToggle(item.id)
  }, [handleToggle, item.id])

  const params = {
    isOpen: open,
    onToggle: toggle,
  }

  return (
    <>
      {render(item, params)}
      {hasChild && open && <Container parentId={id} />}
    </>
  )
}

Node.propTypes = {
  id: PropTypes.string.isRequired,
}

const Tree = ({ folders, render, containerStyles, initialOpenIds }) => {
  const { openIds, handleToggle } = useOpenIds(initialOpenIds)
  return (
    <TreeContext.Provider
      value={{
        folders,
        openIds,
        handleToggle,
        render,
        containerStyles,
      }}
    >
      <Container parentId={0} />
    </TreeContext.Provider>
  )
}
Tree.defaultProps = {
  containerStyles: {},
  initialOpenIds: [],
}

Tree.propTypes = {
  folders: PropTypes.oneOfType([PropTypes.array, PropTypes.shape]).isRequired,
  render: PropTypes.func.isRequired,
  containerStyles: PropTypes.oneOfType([PropTypes.object, PropTypes.shape]),
  initialOpenIds: PropTypes.oneOfType([PropTypes.array, PropTypes.shape]),
}

export default Tree
